import React, { useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { UdafSketch } from '@acclaim/udaf-kit';
import { makeStyles, Paper, Button } from '@material-ui/core';
import {
  Undo as UndoIcon,
  Redo as RedoIcon,
} from '@material-ui/icons';

import ears from 'img/sheepEars.png';

const { SketchField, Tools } = UdafSketch;

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'inline-block',
    padding: '25px',
    marginBottom: '10px',
  },
  controls: {
    textAlign: 'center',
    marginTop: '15px',
  },
  tool: {
    fontSize: '12px',
    margin: '5px',
    '& svg': {
      fontSize: '14px',
      marginRight: '5px',
    },
  },
}));

const EarSketch = ({ onChange, defaultValue }) => {
  const classes = useStyles();
  const sketchRef = useRef();

  const handleUndo = () => {
    if (sketchRef.current.canUndo()) {
      sketchRef.current.undo();
    }
  };

  const handleRedo = () => {
    if (sketchRef.current.canRedo()) {
      sketchRef.current.redo();
    }
  };

  const handleSketchChange = () => {
    onChange(sketchRef.current.toJSON());
  };

  const clearSketch = () => {
    sketchRef.current.clear();
    sketchRef.current.setBackgroundFromDataUrl(
      ears,
      { streched: true },
    );
    onChange(null);
  };

  useLayoutEffect(() => {
    sketchRef.current.setBackgroundFromDataUrl(
      ears,
      { streched: true },
    );
  }, []);

  return (
    <Paper elevation={2} className={classes.wrapper}>
      <SketchField
        name="earSketch"
        width={261}
        height={98}
        tool={Tools.Pencil}
        lineColor='black'
        lineWidth={8}
        ref={sketchRef}
        defaultValue={defaultValue}
        onChange={handleSketchChange}
      />
      <div className={classes.controls}>
        <Button
          className={classes.tool}
          size="small"
          color="primary"
          variant="contained"
          onClick={handleUndo}
        >
          <UndoIcon /> Undo
        </Button>
        <Button
          className={classes.tool}
          size="small"
          color="primary"
          variant="contained"
          onClick={handleRedo}
        >
          <RedoIcon /> Redo
        </Button>
        <Button
          className={classes.tool}
          size="small"
          color="primary"
          variant="contained"
          onClick={clearSketch}
        >
          Clear
        </Button>
      </div>
    </Paper>
  );
};

EarSketch.propTypes = {
  defaultValue: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default EarSketch;
